import React, {Component, Fragment, useContext, useState} from 'react';
import {Link, Route} from "react-router-dom";
import {isEdge, isIE, isSafari} from "react-device-detect";
import moment from "moment";
import {Collapse} from "@material-ui/core";

import {Button, QtySelector, RelativeSwitch} from "../common/common";
import {
	arrayToObject,
	clamp,
	formatPrice,
	mapArray,
	mapArrayToObject,
	mapObjectToArray,
	relativePath,
	scrollTo,
	toggleState,
} from "../../lib/tools";
import {reduxWrapper} from "../../globalState";
import {BannerHeader} from "../structure";
import {getImage} from "../../lib/api";
import {ModalContext} from './../../contexts';
//Icons
import GreenLongArrow from "../../resources/icons/greenArrow.svg"
import CloseIcon from "../../resources/icons/x-black.svg"
import DropArrowIcon from "../../resources/icons/downArrow-black.svg";
//Images
import bgImg from "../../resources/images/bg-register.jpg"
import {BundleProductModal} from '../common/modal';
import { PromptModal } from './../common/modal';

// Take care of Bundles routing
class BundlesRender extends Component {
	state = {
		bundles: []
	};

	mounted = true;
	
	componentWillMount() {
		this.props.apiCall("GET", "products/bundles", x => this.mounted && this.setState({bundles: arrayToObject(x, "identifier")}));
	}

	componentWillUnmount() {
		this.mounted = false;
	}
	
	render() {
		return (
			<RelativeSwitch>
				<Route path=":identifier" render={({match: {params: {identifier}}}) => {
					const bundle = this.state.bundles[identifier];
					if (!bundle) return <BundlesList bundles={this.state.bundles}/>;
					return <SingleBundleView bundle={bundle}/>;
				}}/>
				<Route render={() => <BundlesList bundles={this.state.bundles}/>}/>
			</RelativeSwitch>
		)
	}
}
const Bundles = reduxWrapper("getApiCall")(BundlesRender);

// The list of all the bundles for a given party type
export class BundlesListRender extends Component {
	render() {
		const {bundles} = this.props;
		return (
			<div className="bundlesListWrapper">
				<BannerHeader bgImage={bgImg}>
					<h1>Grydeklare fester</h1>
					<p>Vi har sammensat en række skønne fester, der er klar til at blive holdt.</p>
				</BannerHeader>
				<div className="bundlesListContainer maxWidth">
					{mapObjectToArray(bundles, (x, i) => (
						x.id !== 11 &&
						<BundlePreview bundle={x} key={i}/>
					))}
				</div>
			</div>
		)
	}
}
const BundlesList = reduxWrapper("loadPartyInfo", "setPartyInfo", "addGuests")(BundlesListRender);

// A bundle preview item for the BundlesList
const BundlePreview = (
	{ bundle: {identifier, id, image, title, shortDescription, price},
		children, 
		...props
	} ) => (
	<Link className="bundlePreview" to={relativePath(`${identifier}`)}>
		<div className="bundleImages" style={{backgroundImage: `url(${getImage(image)})`}}>
			{/* <Image src={getImage(image)}/> */}
			<div>
				<div className="pricePP">
					<h1>{formatPrice(price / 10)}.-</h1>
					<span>Pr person</span>
				</div>
				{/* <Image src={getImage(image)}/> */}
			</div>
			{/* <Image src={getImage(image)}/> */}
			{/* <Image src={getImage(image)}/> */}
		</div>
		<div className="bundleText">
			{/* <span className="bundleCategory">Fest for vennerne</span> */}
			<h1>{title}</h1>
			<div className="bundleDescWrapper">
				<span className="line"/>
				<span className="bundleDesc">{shortDescription}</span>
			</div>
			<div className="bundleMoreBtn">
				<span>Læs mere</span>
				<img src={GreenLongArrow} alt="Læs mere"/>
			</div>
		</div>
	</Link>
);

// A detailed view for a single bundle
export class SingleBundleViewRender extends Component {
	static contextType = ModalContext;
	state = {
		guests: 10,
		productData: {total: 0, products: [], sortedProd: [], disabled: false},
		qtyOverride: {},
		disabled: {},
		dateWarning: false,
		descExtended: false
	};
	
	timeout = null;
	
	updateBundle = () => {
		this.setState(prev => ({
			qtyOverride: {},
			productData: extractProductData(this.props.bundle.products, this.props.products, prev.guests, {}, prev.disabled, this.props.sections)
		}));
	};
			
	changeAmount = (amount) => {
		this.setState({guests: clamp(amount, 5, 99)});
		clearTimeout(this.timeout);
		this.timeout = setTimeout(
			this.updateBundle,
			500
		);
	};
			
	editProductQty = (prod, qty) => {
		this.setState(prev => ({
			qtyOverride: {...prev.qtyOverride, [prod]: qty},
			productData: extractProductData(this.props.bundle.products, this.props.products, prev.guests, {
				...prev.qtyOverride,
				[prod]: qty
			}, prev.disabled)
		}));
	};
			
	// toggleProduct = prod => {
	// 	this.setState(prev => ({
	// 		disabled: {...prev.disabled, [prod]: !prev.disabled[prod]},
	// 		productData: extractProductData(this.props.bundle.products, this.props.products, prev.guests, prev.qtyOverride, {
	// 			...prev.disabled,
	// 			[prod]: !prev.disabled[prod]
	// 		})
	// 	}));
	// };

	addToCart = route => {
		const date = this.props.partyInfo ? this.props.partyInfo.time : null;
		
		const prods = mapArray(this.state.productData.products,
			({qtyOrdered, sections, configurationId, id, disabled}) => {
				if (disabled) return null;
				const options = this.props.products[id].customOptions || [];
				return {
					qty: qtyOrdered,
					section: sections[0] || null,
					configurationId,
					productId: id,
					customOptions: mapArrayToObject(options, x => x.type === "datetime" ? {
						key: x.id,
						data: moment(date).format("YYYY-MM-DD hh:mm:ss")
					} : null)
				};
			}
		);
		this.props.clearCart().then(() => {
			this.props.addMultipleToCart({
				products: prods,
				success: () => this.props.history.push(`${route}`)
			});
		});
	};

	promptCheckout = {
		text: "Køb eller reserver din fest! Når man reservere en fest betales der en uge før festen afholdelse.",
		confirm: () => {
			this.context.toggleModal(false);
			this.addToCart("/reservere");
		},
		decline: () => {
			this.context.toggleModal(false);
			this.addToCart("/checkout");
		},
		confirmText: "Reserver til senere",
		declineText: "Køb nu"
	};
	
	componentWillMount() {
		this.props.cacheProduct({products: this.props.bundle.products.map(x => x.id), full: true}).then(() => this.updateBundle());
	}
	
	componentDidMount() {
		if (isIE || isEdge || isSafari) {
			scrollTo(document.getElementsByClassName("bundleTop")[0]);
		} else {
			document.getElementById("content").scrollTo(0, 0);
		}
	}
	
	render() {
		const {bundle: {title, description, image}} = this.props;
		const {productData: {total, sortedProd}, guests} = this.state;
		return (
			<div className="singleBundlePageWrapper">
				
				<div className="singleBundlePageContainer maxWidth">
					<Link className="close" to={relativePath("..")}>
						<img src={CloseIcon} alt="Tilbage"/>
					</Link>
					<div className="imagesWrapper" style={{backgroundImage: `url(${getImage(image)})`}}>
					</div>
					<div className="infoWrapper">
						<div className="infoContent">
							<h1 className="title-l">{title}</h1>

							<span className="pricePP">Fra {formatPrice(total / guests)} kr pr person</span>
							
							<div className={["bundleDescWrapper", this.state.descExtended ? "extended" : ""].join(" ")}>
								<div className="bundleDesc" dangerouslySetInnerHTML={{__html: description}}/>
								<div className="showMoreWrapper">
									<div className="showMoreBtn" onClick={() => this.setState(toggleState("descExtended"))}>VIS MERE</div>
								</div>
							</div>

							<div className="bundleProductsWrapper">
								<h2>Pakkens indhold</h2>
								{
									mapObjectToArray(sortedProd, (x, i) =>
										sortedProd["Maden"].length > 0 ?
											<BundleListSection key={i} title={i} sections={x} open={i === "Maden"}/> :
											<BundleListSection key={i} title={i} sections={x} open={i === "Drikkevarer"}/>
									)
								}
								<span>I alt: {formatPrice(total)}</span>
							</div>
						</div>

						<div className="singleBundleBtns">
							<div className="qtyWrapper">
								<span>Antal gæster</span>
								<QtySelector value={guests} onChange={val => this.changeAmount(val)} min={10}/>
							</div>
							<Button onClick={() => this.addToCart("/minfest")} className="light ga-tilpasPakke">Tilpas</Button>
							<Button 
								className="ga-checkoutPakke"
								onClick={
									() => this.context.toggleModal(true,
										<PromptModal {...this.promptCheckout}/>
									)
								}
							>
								Lav bestilling
							</Button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}
const SingleBundleView = reduxWrapper("loadSections", "getCacheProduct", "loadProducts", "getAddMultipleToCart", "setPartyInfo", "loadPartyInfo", "getClearCart")(SingleBundleViewRender);

export function extractProductData(items, products, amount, qtyOverride = {}, disabledLookup = {}, sections) {
	let total = 0;
	let disabledTotal = 0;
	let newProducts = mapObjectToArray(items, item => {
		const id = item.id;
		const prod = products[id];
		if (!prod || !prod.info) return null;
		
		let config = null;
		let price = prod.price;
		
		if (item.configurationId) {
			if (!prod.full || !prod.configurations) return null;
			config = prod.configurations.find(y => y.id === item.configurationId);
			if (!config) return null;
			price = config.price;
		}
		
		let qty = amount >= 30 ?
			Math.ceil((item.qty30 / 30) * amount) :
			(
				amount >= 20 ? Math.ceil(item.qty20 + ((item.qty30 - item.qty20) / 10) * (amount % 10)) :
					(
						amount >= 10 ? Math.ceil(item.qty10 + ((item.qty20 - item.qty10) / 10) * (amount % 10)) :
							Math.ceil((item.qty10 / 10) * amount)
					)
			);
		qty = qty == null ? 1 : qty;
		if (qtyOverride.hasOwnProperty(id)) qty = qtyOverride[id];
		const minQty = prod.info.minQty || 1;
		
		const disabled = disabledLookup[id] || qty < minQty;
		
		if (!disabled)
			total += qty * price;
		else if (!disabledLookup[id])
			disabledTotal += 1;
		
		const units = prod.info.percent && prod.info.capacity ? Math.max(1, Math.round((qty * prod.info.percent * prod.info.capacity) / (150 * amount))) : null;
		
		return {
			...prod,
			qtyOrdered: qty,
			config,
			actualPrice: price,
			disabled,
			configurationId: item.configurationId,
			units
		};
	});

	const sortedProd = sortProdBySection(newProducts, sections);

	return {total, products: newProducts, sortedProd, disabled: disabledTotal > 0};
}

export const sortProdBySection = (products, sections) => {
	console.log(products);
	let sorted = {
		"Maden": []
	};

	let sectionsArr = Object.values(sections);

	//Loop through the products
	for(let g = 0; g < products.length; g++){
		// loop through the sections to get to the sub sections
		for(let i = 0; i < sectionsArr.length; i++){
			//for each product, check whitch subsection it belongs to
			for(let x = 0; x < sectionsArr[i].children.length; x++){
				if(sectionsArr[i].children[x].id === Number(products[g].sections[0])){
					if(Object.keys(sorted).includes(sectionsArr[i].title)){
						if(products[g].sections[0] === "9"){
							sorted[sectionsArr[i].title].unshift(products[g])
						}else{
							sorted[sectionsArr[i].title].push(products[g])
						}
					}else{
						sorted[sectionsArr[i].title] = [products[g]];
					}
				}
			}
		}
	}
	console.log(sorted);
	return sorted;
}

const BundleListSectionRender = ({title, sections, open, contest = false}) => {
	const [showProducts, setShowProducts] = useState(open);

	return (
		<div className="bundleProdSection">
			{sections.length > 0 &&
				<Fragment>
					<div className="toggleWrapper" onClick={() => setShowProducts(showProducts ? false : true)}>
						<h2 className="bundleProdTitle">{title}</h2>
						<img className={showProducts ? "flip" : ""} src={DropArrowIcon} alt="dropDown"/>
					</div>
					<Collapse in={showProducts}>
						<div>
							<BundleListProduct sections={sections} contest={contest}/>
						</div>
					</Collapse>
				</Fragment>
			} 
		</div>
	)
};
export const BundleListSection = reduxWrapper("products", "getCacheProduct")(BundleListSectionRender);

const BundleListProduct = ({sections, contest}) => {
	const context = useContext(ModalContext);

	return (
		sections.map((x, i) => 
			<div 
				key={i} 
				className="sectionProduct" 
				style={	x.disabled ? {opacity: ".25"} : {}} 
				onClick={() => context.toggleModal(true, <BundleProductModal product={x}/>)}
			>
				<div className="prodImg">
					<img src={getImage(x.thumbnail)} alt={x.name}/>
				</div>
				<div className="prodInfo">
					<span className="prodName">{x.qtyOrdered} x {x.name}</span>
					{
						x.sections.includes("9") &&
						<div className="foodDescriptionWrapper" dangerouslySetInnerHTML={{__html: x.description}}/>
					}
					{ !contest && 
						<span className="prodPrice">{Number(x.price) * x.qtyOrdered}</span>
					}
				</div>
			</div>
		)
	)
};


export default Bundles;


// WEBPACK FOOTER //
// ./src/components/views/bundles.js